import Axios from "axios";
import router from '../router'

const API = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    XMLHttpRequest: "XMLHttpRequest",
    Club: `${localStorage.getItem("club_id")}`,
    Authorization: {
      toString() {
        return `Bearer ${localStorage.getItem("access_token")}`;
      },
    },
  },
});

API.interceptors.request.use(
  (config) => {
    const role = localStorage.getItem("role");
    if (role) {
      config.headers.Role = role;
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);


// Response interceptor
API.interceptors.response.use(
  (response) => {
    return response
  },
  async (error) => {

    const res = error.response

    if (res?.status === 403 && res.data?.setup_required) {
      router.push({ name: 'Setup2FA', query: { id: res.data.user } })
    }
    
    return Promise.reject(error)
  },
)

export default API;
